import { Grid, Typography } from "@mui/material";
import React from "react";
import { useDepositStyles } from "./deposit.styles";

const PLEASE_NOTE_TEXT =
  "To successfully submit this deposit, you will need to enter your transaction ID and the unit amount deposited below.";

const PleaseNote = (): JSX.Element => {
  const classes = useDepositStyles();

  return (
    <Grid container className={classes.pleaseNoteContainer}>
      <Grid item>
        <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
          <u>PLEASE NOTE:</u>
        </Typography>
      </Grid>
      <br />
      <Grid item>
        <Typography sx={{ fontSize: "14px" }}>{PLEASE_NOTE_TEXT}</Typography>
      </Grid>
    </Grid>
  );
};

export default PleaseNote;
